module.exports = __webpack_public_path__ + "static/media/logo192.5eea2832.png";